import { useNode } from '@craftjs/core';
import { TOTPImage } from '@descope/page-editor-components';
import React, { CSSProperties, useCallback } from 'react';
import { EditorTOTPImageSettings } from './EditorTOTPImageSettings';
import totpPlaceholder from './totpPlaceholder.svg';

type Props = React.ComponentProps<typeof TOTPImage>;

const EditorTOTPImage = (props: Props) => {
	const {
		connectors: { connect, drag }
	} = useNode((state) => ({
		hasSelectedNode: state.events.selected,
		hasDraggedNode: state.events.dragged
	}));

	const refCb = useCallback(
		(ref: HTMLImageElement) => connect(drag(ref)),
		[connect, drag]
	);

	return (
		<div ref={refCb}>
			<TOTPImage
				{...props}
				style={{ '--totp-image': `url(${totpPlaceholder})` } as CSSProperties}
			/>
		</div>
	);
};

EditorTOTPImage.craft = {
	name: 'TOTP QR Code',
	props: {
		width: undefined,
		height: 100, // this is the default height
		alt: 'QR Code'
	},
	related: {
		settings: EditorTOTPImageSettings
	}
};

export { EditorTOTPImage };
